import { render, staticRenderFns } from "./A3ArchivedBoardCollectionPage.vue?vue&type=template&id=0a8fab34&"
import script from "./A3ArchivedBoardCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./A3ArchivedBoardCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8fab34')) {
      api.createRecord('0a8fab34', component.options)
    } else {
      api.reload('0a8fab34', component.options)
    }
    module.hot.accept("./A3ArchivedBoardCollectionPage.vue?vue&type=template&id=0a8fab34&", function () {
      api.rerender('0a8fab34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/A3/A3ArchivedBoardCollectionPage.vue"
export default component.exports